import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { roleMap } from "../../Utills/enums";
import { useNavigate } from "react-router-dom";
import ChangePassword from "./ChangePassword";
import { logout, openGlobalPopup, closeGlobalPopup } from '../../redux/action';
import GlobalPopup from "../../component/Popup/GlobalPopup.js";
import { Power, LockKeyhole } from "lucide-react";

const ProfileDropdown = () => {

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();
  const user = JSON.parse(localStorage.getItem("admin_token_info")) || {};
  const avatarLetter = user?.name ? user.name.charAt(0).toUpperCase() : "U";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  console.log("user", user)

  const toggleDropdown = () => {
    setOpen(!open);
  };

  const handleLogout = () => {
    // localStorage.removeItem("jwtToken");
    // localStorage.clear();
    // window.location.href = "/";

    try {
      dispatch(logout());
      console.log("Logout:"); // token or restros

    } catch (error) {
      console.error("Logot failed:", error.message);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const showChangePasswordPopup = () => {
    dispatch(openGlobalPopup("change-password"));
    setOpen(false);
  }

  return (
    <div className="profile-wrapper" ref={dropdownRef}>
      {/* Avatar Button */}
      <div className="avatar-btn" onClick={toggleDropdown}>
        <div className="avatar-circle">{avatarLetter}</div>
      </div>

      {open && (
        <div className="profile-menu">

          {/* Profile Header */}
          <div className="profile-header">
            <div className="avatar-large">{avatarLetter}</div>
            <div>
              <div className="profile-name">{user?.name}</div>
              <div className="profile-role">Restaurant {roleMap[user?.roleId]}</div>
              <div className="profile-phone">{user?.userName}</div>
            </div>
          </div>

          <div className="menu-divider"></div>

          {/* Menu Items */}
          <div className="menu-item" onClick={showChangePasswordPopup}>
            <LockKeyhole size={16} color="var(--ui-danger-text)" strokeWidth={3} className="sidebar-icon" /> Change Password
          </div>

          <div className="menu-item logout" onClick={handleLogout}>
            <Power size={13} color="var(--ui-danger-text)" strokeWidth={3} className="sidebar-icon" />  Logout
          </div>
        </div>
      )}

      {/* ✅ GlobalPopup OUTSIDE dropdown 🚪 */}

      <GlobalPopup popupKey="change-password" title="Change Password">
        <ChangePassword />
      </GlobalPopup>

    </div>
  );
};

export default ProfileDropdown;

